export default "__VITE_ASSET__BTpKaJk0__"